"use client";

import { c as _c } from "react/compiler-runtime";
import type { CampaignPageSection } from "@growwithai/shared";
import SafeImage from "@/components/common/SafeImage";
import { isSafeHref } from "../types";
import { sectionBgStyle, sectionHeadingStyle } from "../section-style";
type ImageSectionData = Extract<CampaignPageSection, {
  type: "image";
}>;
const MAX_WIDTH_CLASS: Record<ImageSectionData["max_width"], string> = {
  sm: "max-w-md",
  md: "max-w-2xl",
  lg: "max-w-4xl",
  full: "max-w-6xl"
};

/** Satu gambar banner — opsional caption & tautan (beda dari 'gallery' yang grid). */
export default function ImageSection(t0) {
  const $ = _c(20);
  const {
    section
  } = t0;
  const t1 = section.alt ?? "";
  let t2;
  if ($[0] !== section.url || $[1] !== t1) {
    t2 = <SafeImage src={section.url} alt={t1} loading="lazy" className="w-full rounded-2xl object-cover" />;
    $[0] = section.url;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const img = t2;
  let t3;
  if ($[3] !== section.custom_style) {
    t3 = sectionBgStyle(section.custom_style);
    $[3] = section.custom_style;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = `mx-auto px-5 ${MAX_WIDTH_CLASS[section.max_width]}`;
  let t5;
  if ($[5] !== img || $[6] !== section.link_url) {
    t5 = section.link_url && isSafeHref(section.link_url) ? <a href={section.link_url} target={/^https?:\/\//i.test(section.link_url) ? "_blank" : undefined} rel="noopener noreferrer">{img}</a> : img;
    $[5] = img;
    $[6] = section.link_url;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== section.caption || $[9] !== section.custom_style) {
    t6 = section.caption && <figcaption className="mt-2.5 text-center text-[13px] text-gray-500" style={sectionHeadingStyle(section.custom_style)}>{section.caption}</figcaption>;
    $[8] = section.caption;
    $[9] = section.custom_style;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== t5 || $[12] !== t6) {
    t7 = <figure>{t5}{t6}</figure>;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t4 || $[15] !== t7) {
    t8 = <div className={t4}>{t7}</div>;
    $[14] = t4;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t3 || $[18] !== t8) {
    t9 = <section className="bg-white py-10 md:py-14" style={t3}>{t8}</section>;
    $[17] = t3;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}